var _excluded = ["children", "className", "mode", "theme", "disabled", "onClick", "size", "bold", "before", "after", "preventDefault", "isColorfulIcon", "as", "data-qa"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { useCallback } from "react";

var Link = _ref => {
  var {
    children,
    className,
    mode = "default",
    theme = "primary",
    disabled,
    onClick,
    size = "medium",
    bold,
    before,
    after,
    preventDefault = true,
    isColorfulIcon,
    as,
    "data-qa": dataQa = "link"
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleClick = useCallback(event => {
    if (preventDefault && onClick || disabled) {
      event.preventDefault();
    }

    if (!disabled && onClick) {
      onClick(event);
    }
  }, [disabled, onClick, preventDefault]);
  var cn = ["glz-link", size && "glz-is-".concat(size), mode && "glz-is-".concat(mode), theme && "glz-is-".concat(theme), disabled && "glz-is-disabled", bold && "glz-is-bold", className].filter(Boolean).join(" ");
  var beforeCn = ["glz-before-icon", isColorfulIcon && "glz-is-colorfull-icon"].filter(Boolean).join(" ");
  var afterCn = ["glz-after-icon", isColorfulIcon && "glz-is-colorfull-icon"].filter(Boolean).join(" ");
  var As = as !== null && as !== void 0 ? as : "a";
  var commonProps = {};

  if (As === "a") {
    commonProps = {
      role: "link"
    };
  } else if (As === "button") {
    commonProps = {
      type: "button"
    };
  }

  return /*#__PURE__*/React.createElement(As, _extends({}, commonProps, {
    "data-qa": dataQa
  }, props, {
    className: cn,
    onClick: handleClick
  }), before && /*#__PURE__*/React.createElement("span", {
    className: beforeCn
  }, before), children, after && /*#__PURE__*/React.createElement("span", {
    className: afterCn
  }, after));
};

export default Link;